import { PaymentMethod, TinyPayloads } from '@openeducation/pp-rn-shared-types';

export function validateTwoCreditCardsRequirements(
  availablePaymentMethods: PaymentMethod[],
  tinyPayloads: TinyPayloads
): void {
  const hasTwoCreditCards = availablePaymentMethods.includes(
    PaymentMethod.TWO_CREDIT_CARDS
  );
  const hasMainPaymentMinPercentage =
    tinyPayloads.mainPaymentMinPercentage !== undefined;

  if (hasTwoCreditCards && !hasMainPaymentMinPercentage) {
    throw new Error(
      'TWO_CREDIT_CARDS payment method is available but mainPaymentMinPercentage is missing in tiny payloads'
    );
  }
}
